export default {
  title: "Aksiyalar",
  newPromotion: "Yangi aksiya",
  createNewPromo: "Yangi aksiya yaratish",
  creatingNewPromo: "Yangi aksiya yaratilmoqda",
  name: "Aksiya nomi",
  promoEditor: "Aksiyalar tahrirchisi",
  cashback: "Keshbek foizi",
  discount: "Chegirma foizi",
  activate: "Aksiyani faollashtirish",
  deactivate: "Aksiyani o‘chirish",
  noPromotions: "Sizda hali aksiyalar yo‘q",
  createWarning: "*Bir savdo nuqtasiga uchta faol aksiya gacha ruxsat etiladi",
  createWarningLimit:
    "Ushbu savdo nuqtasi uchun maksimal aksiya soni yaratilgan",
  headersList: {
    name: "Aksiya nomi",
    tradingPoint: "Savdo nuqtasi",
    cashback: "Keshbek foizi",
    discount: "Chegirma foizi",
  },
  delete: "Haqiqatan ham o‘chirilsinmi ",
  aboutChapter: "Bo‘lim haqida",
  aboutChapterDescriptions: [
    "«Aksiyalar» bo‘limi turli chegirma va mukofot foizlariga ega mahsulotlarni boshqarishga yordam beradi. Siz yaratgan aksiya RC KASSA ilovasida ko‘rinadi va darhol qo‘llanilishi mumkin.",
    "Bir savdo nuqtasida bir vaqtning o‘zida 3 ta faol aksiya bo‘lishi mumkin.",
  ],
  deletePromo: "Aksiyani o‘chirish",
};
